import Vue from 'vue/dist/vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import products from './modules/products'
import storages from './modules/storages'
import user from './modules/user'
// import createLogger from '../plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    cart,
    products,
    storages,
    user,
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : [],
})

/* eslint-disable no-unused-vars */
function planyo_payment_send() {
  return false
}
